/**
 * Savvyy Filter Drawer v2 — Complete rewrite
 * No cached DOM refs. All queries are fresh. Event delegation for robustness.
 */
(function () {
  'use strict';

  // Only run on collection and search pages
  if (!document.querySelector('[data-template^="collection"]') && !document.querySelector('[data-template="search"]')) return;

  // --- Utilities ---
  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.from((scope || document).querySelectorAll(sel)); }

  // Menu-driven "Style" sub-collections (rendered as JSON by main-collection.liquid)
  function getStyleData() {
    var el = document.querySelector('.sfd-style-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent.trim()) || []; } catch (e) { return []; }
  }

  // Search-page Style data: FLAT list { subs: [ {title,url} ] } — same shape as
  // the collection page, so the search filter uses the same multi-select UI.
  function getSearchStyleData() {
    var el = document.querySelector('.sfd-search-style-data');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent.trim());
      return (data && data.subs && data.subs.length) ? data : null;
    } catch (e) { return null; }
  }

  // --- State ---
  var pendingSortIndex = null; // sort selection stored until VIEW is clicked
  var pendingStyle = null; // {url,title} chosen style (legacy search single), applied on VIEW ITEMS
  var collectionStyleTags = []; // collection page multi-select style tags, applied on VIEW ITEMS
  var searchStyleTags = []; // search page multi-select style tags, applied as filter.p.tag on /search

  // --- DOM Creation (one-time) ---
  var bar = null;
  var drawer = null;
  var backdrop = null;

  function ensureUI() {
    if (document.querySelector('.sfd-bar')) return;

    // Clean up any orphaned drawers/backdrops left over from a previous
    // section render (the morph re-init can otherwise stack duplicates).
    qsa('.sfd-drawer').forEach(function (el) { el.remove(); });
    qsa('.sfd-backdrop').forEach(function (el) { el.remove(); });
    drawer = null;
    backdrop = null;

    var facets = qs('.facets--horizontal');
    if (!facets) return;

    var overflowList = qs('.facets__overflow-list', facets);
    if (!overflowList) return;

    var filterItems = qsa('.facets__item', overflowList);

    // --- Create Bar ---
    bar = document.createElement('div');
    bar.className = 'sfd-bar';

    var barLeft = document.createElement('div');
    barLeft.className = 'sfd-bar__left';

    // Filter icon
    barLeft.innerHTML = '<span class="sfd-bar__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg></span>';

    // Filter buttons
    filterItems.forEach(function (item, i) {
      var label = qs('.facets__label', item);
      if (!label) return;
      if (label.textContent.trim().toLowerCase() === 'brands') return;
      // Skip the native "Style" (Tags source) facet — it's replaced by our
      // custom menu-driven Style button appended below. Without this we'd get
      // TWO "STYLE" buttons in the bar (native + custom).
      if (label.textContent.trim().toLowerCase() === 'style') return;
      var btn = document.createElement('button');
      btn.className = 'sfd-bar__btn';
      btn.type = 'button';
      btn.dataset.target = 'filter-' + i;
      btn.textContent = label.textContent.trim().toUpperCase();
      barLeft.appendChild(btn);
    });

    // Sort button
    var sortBtn = document.createElement('button');
    sortBtn.className = 'sfd-bar__btn sfd-bar__btn--sort';
    sortBtn.type = 'button';
    sortBtn.dataset.target = 'sort';
    sortBtn.textContent = 'SORT';
    barLeft.appendChild(sortBtn);

    // Collection-page Style button (single-level sub-collections)
    var styleDataForBar = getStyleData();
    if (styleDataForBar && styleDataForBar.subs && styleDataForBar.subs.length > 0) {
      var styleBtn = document.createElement('button');
      styleBtn.className = 'sfd-bar__btn sfd-bar__btn--style';
      styleBtn.type = 'button';
      styleBtn.dataset.target = 'sfd-style';
      styleBtn.textContent = 'STYLE';
      barLeft.appendChild(styleBtn);
    }

    // Search-page Style button (two-level: main category -> sub-collections)
    if (getSearchStyleData()) {
      var styleSearchBtn = document.createElement('button');
      styleSearchBtn.className = 'sfd-bar__btn sfd-bar__btn--style-search';
      styleSearchBtn.type = 'button';
      styleSearchBtn.dataset.target = 'sfd-style-search';
      styleSearchBtn.textContent = 'STYLE';
      barLeft.appendChild(styleSearchBtn);
    }

    bar.appendChild(barLeft);

    // Pills container
    var pillsContainer = document.createElement('div');
    pillsContainer.className = 'sfd-bar__pills';

    // Insert bar into DOM
    var resultsEl = qs('results-list') || qs('.product-grid-container');
    if (resultsEl) {
      resultsEl.parentNode.insertBefore(bar, resultsEl);
      bar.parentNode.insertBefore(pillsContainer, bar.nextSibling);
    }

    // --- Create Drawer ---
    backdrop = document.createElement('div');
    backdrop.className = 'sfd-backdrop';
    document.body.appendChild(backdrop);

    drawer = document.createElement('div');
    drawer.className = 'sfd-drawer';
    drawer.innerHTML =
      '<div class="sfd-drawer__header">' +
        '<div class="sfd-drawer__pills"></div>' +
        '<button class="sfd-drawer__close" aria-label="Close" type="button">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="sfd-drawer__content"></div>' +
      '<div class="sfd-drawer__footer">' +
        '<button class="sfd-drawer__view-btn" type="button">VIEW ITEMS</button>' +
      '</div>';
    document.body.appendChild(drawer);

    // --- Event Listeners (delegation) ---
    bar.addEventListener('click', handleBarClick);
    backdrop.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', handleDrawerClick);
    drawer.addEventListener('change', handleDrawerChange);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Initial pills render
    renderBarPills();
  }

  // --- Get Active Filters (always fresh) ---
  // The theme reorganizes facet items between .facets__overflow-list,
  // .facets-drawer__filters and (when our drawer is open) .sfd-drawer__content,
  // especially after a section morph. Scan all of them and dedupe by name::value
  // so we always detect the real active filters regardless of where they live.
  function getActiveFilters() {
    var active = [];
    var seen = {};
    var checkedInputs = qsa(
      '.facets--horizontal input[type="checkbox"]:checked,' +
      '.facets-drawer__filters input[type="checkbox"]:checked,' +
      '.sfd-drawer__content input[type="checkbox"]:checked'
    );
    checkedInputs.forEach(function (input) {
      if (!input.name || !input.value) return;
      // Ignore the native Style (Tags) facet — style is managed by our
      // custom menu-driven filter, which renders its own pills.
      if (input.name === 'filter.p.tag') return;
      var key = input.name + '::' + input.value;
      if (seen[key]) return;
      seen[key] = true;
      var inputLabel = input.dataset.label || input.value || '';
      var li = input.closest('li');
      if (li) {
        var labelEl = qs('.checkbox__label-text, label, .facets__pill-label', li);
        if (labelEl) inputLabel = labelEl.textContent.trim();
      }
      active.push({ filterName: '', label: inputLabel, input: input });
    });
    return active;
  }

  // Uncheck every copy of a filter (name+value) across the facets system,
  // then trigger the theme's update via a change event.
  function removeFilter(input) {
    if (!input) return;
    var name = input.name;
    var value = input.value;
    var matches = qsa('input[type="checkbox"]').filter(function (i) {
      return i.name === name && i.value === value && i.checked;
    });
    if (matches.length === 0) matches = [input];
    matches.forEach(function (i) { i.checked = false; });
    matches[0].dispatchEvent(new Event('change', { bubbles: true }));
  }

  // --- Render Pills (bar) ---
  function renderBarPills() {
    var pillsContainer = qs('.sfd-bar__pills');
    if (!pillsContainer) return;
    var active = getActiveFilters();
    if (active.length === 0) {
      pillsContainer.innerHTML = '';
      pillsContainer.style.display = 'none';
      return;
    }
    pillsContainer.style.display = 'flex';
    var html = '';
    active.forEach(function (f, i) {
      html += '<span class="sfd-pill" data-pill-index="' + i + '">' + f.label + ' <button type="button" class="sfd-pill__x" data-pill-index="' + i + '">\u2715</button></span>';
    });
    html += '<button type="button" class="sfd-pills-clear">Clear All</button>';
    pillsContainer.innerHTML = html;

    // Update bar button counts
    updateBarButtonCounts();
  }

  // --- Update bar button text with filter counts ---
  function updateBarButtonCounts() {
    if (!bar) return;
    var overflowList = qs('.facets--horizontal .facets__overflow-list');
    if (!overflowList) return;
    var filterItems = qsa('.facets__item', overflowList);

    filterItems.forEach(function (item, i) {
      var label = qs('.facets__label', item);
      if (!label) return;
      if (label.textContent.trim().toLowerCase() === 'brands') return;
      var btn = qs('[data-target="filter-' + i + '"]', bar);
      if (!btn) return;
      var count = qsa('input[type="checkbox"]:checked', item).length;
      var text = label.textContent.trim().toUpperCase();
      if (count > 0) text += ' (' + count + ')';
      btn.textContent = text;
    });
  }

  // --- Render Drawer Pills ---
  function renderDrawerPills() {
    var drawerPills = qs('.sfd-drawer__pills', drawer);
    if (!drawerPills) return;
    var active = getActiveFilters();
    if (active.length === 0 && !pendingStyle && collectionStyleTags.length === 0 && searchStyleTags.length === 0) {
      drawerPills.innerHTML = '<p class="sfd-drawer__title">No filters selected</p>';
      return;
    }
    var html = '';
    if (pendingStyle) {
      html += '<span class="sfd-pill sfd-pill--drawer sfd-pill--style">' + pendingStyle.title + ' <button type="button" class="sfd-pill__x" data-style-clear="1">\u2715</button></span>';
    }
    collectionStyleTags.forEach(function (t) {
      html += '<span class="sfd-pill sfd-pill--drawer sfd-pill--style">' + t + ' <button type="button" class="sfd-pill__x" data-style-tag="' + t.replace(/"/g, '&quot;') + '">\u2715</button></span>';
    });
    searchStyleTags.forEach(function (t) {
      html += '<span class="sfd-pill sfd-pill--drawer sfd-pill--style">' + t + ' <button type="button" class="sfd-pill__x" data-sstyle-tag="' + t.replace(/"/g, '&quot;') + '">\u2715</button></span>';
    });
    active.forEach(function (f, i) {
      html += '<span class="sfd-pill sfd-pill--drawer" data-pill-index="' + i + '">' + f.label + ' <button type="button" class="sfd-pill__x" data-pill-index="' + i + '">\u2715</button></span>';
    });
    html += '<button type="button" class="sfd-drawer__clear-btn">Clear All</button>';
    drawerPills.innerHTML = html;
  }

  // --- Open Drawer ---
  function openDrawer(targetId) {
    if (!drawer) return;
    var content = qs('.sfd-drawer__content', drawer);
    content.innerHTML = '';
    pendingSortIndex = null;
    pendingStyle = null;

    var isSearchPage = !!document.querySelector('[data-template="search"]');

    // Move filter items into drawer (fresh query)
    var overflowList = qs('.facets--horizontal .facets__overflow-list');
    if (overflowList) {
      qsa('.facets__item', overflowList).forEach(function (item, idx) {
        var label = qs('.facets__label', item);
        if (label && label.textContent.trim().toLowerCase() === 'brands') return;
        // Hide the native "Style" (Tags) facet inside the drawer on ALL pages.
        // Style is handled by our custom menu-driven section, so the native
        // one must never show (prevents duplicate Style checkboxes).
        var isNativeStyle = label && label.textContent.trim().toLowerCase() === 'style';
        if (isNativeStyle) {
          // Inline !important is required because the drawer CSS forces
          // `.sfd-drawer__content .facets__item { display:block !important }`.
          // A plain inline display:none would be overridden by that rule.
          item.style.setProperty('display', 'none', 'important');
        }
        content.appendChild(item);
        if (!isNativeStyle) {
          item.style.display = 'block';
        }
        item.style.visibility = 'visible';
        item.style.position = 'static';
        item.style.width = '100%';
        var details = qs('details', item);
        if (details) {
          // Only open the clicked filter (index matches the bar button target),
          // keep the others closed.
          if (targetId === 'filter-' + idx) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
          details.removeAttribute('data-auto-close-details');
        }
      });
    }

    // Build sort section
    var sortSection = document.createElement('div');
    sortSection.className = 'sfd-sort-section';
    var sortingFilter = qs('.facets--horizontal .sorting-filter');
    if (sortingFilter) {
      var sortDetails = qs('details', sortingFilter);
      var sortOptions = sortDetails ? qsa('[role="option"]', sortDetails) : [];
      var sortHTML = '<button class="sfd-accordion__trigger" type="button"><span>Sort</span><svg class="sfd-accordion__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></button>';
      sortHTML += '<div class="sfd-accordion__body"><ul class="sfd-sort-list">';
      sortOptions.forEach(function (opt, i) {
        var label = opt.textContent.trim();
        var selected = opt.getAttribute('aria-selected') === 'true';
        sortHTML += '<li><label class="sfd-sort-option"><input type="radio" name="sfd-sort-radio" value="' + i + '"' + (selected ? ' checked' : '') + '><span>' + label + '</span></label></li>';
      });
      sortHTML += '</ul></div>';
      sortSection.innerHTML = sortHTML;
    }
    content.appendChild(sortSection);

    // Open sort accordion if target is sort
    if (targetId === 'sort') {
      sortSection.classList.add('is-open');
    }

    // Build Style section (menu-driven, MULTI-SELECT). "Style" heading, then a
    // "Select style(s)" dropdown of checkbox sub-collections. Multiple can be
    // ticked without closing; applied on VIEW ITEMS as filter.p.tag on the
    // current collection. Auto-updates with the menu.
    var styleData = getStyleData();
    if (styleData && styleData.subs && styleData.subs.length > 0) {
      // Seed selected tags from the current URL (so re-opening keeps state)
      var urlTags = new URLSearchParams(window.location.search).getAll('filter.p.tag');
      collectionStyleTags = [];
      styleData.subs.forEach(function (s) {
        if (urlTags.indexOf(s.title) !== -1) collectionStyleTags.push(s.title);
      });

      var styleSection = document.createElement('div');
      styleSection.className = 'sfd-style-section';
      var styleHTML = '<button class="sfd-accordion__trigger" type="button"><span>Style</span><svg class="sfd-accordion__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></button>';
      styleHTML += '<div class="sfd-accordion__body">';

      styleHTML += '<div class="sfd-style-ms">';
      styleHTML += '<button type="button" class="sfd-style-ms__toggle">' +
        '<span class="sfd-style-ms__label">Select style(s)</span>' +
        '<svg class="sfd-style-ms__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
        '</button>';
      styleHTML += '<div class="sfd-style-ms__menu">';
      styleData.subs.forEach(function (s) {
        var checked = collectionStyleTags.indexOf(s.title) !== -1;
        styleHTML += '<label class="sfd-style-ms__option">' +
          '<input type="checkbox" class="sfd-style-ms__cb" value="' + s.title.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + '>' +
          '<span class="sfd-style-ms__check"></span>' +
          '<span class="sfd-style-ms__text">' + s.title + '</span>' +
          '</label>';
      });
      styleHTML += '</div></div>';

      styleHTML += '</div>';
      styleSection.innerHTML = styleHTML;
      content.appendChild(styleSection);

      if (targetId === 'sfd-style') {
        styleSection.classList.add('is-open');
        // Open the multi-select menu by default so options are visible
        var ms = qs('.sfd-style-ms', styleSection);
        if (ms) ms.classList.add('is-open');
        setTimeout(function () { styleSection.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
      }
    }

    // Build the SEARCH Style section: same MULTI-SELECT "Select style(s)" UI as
    // the collection page. Selected styles are applied as filter.p.tag on the
    // /search results (the `q` query is preserved) via VIEW ITEMS.
    var searchStyle = getSearchStyleData();
    if (searchStyle && searchStyle.subs && searchStyle.subs.length > 0) {
      // Seed selected tags from the current URL (so re-opening keeps state)
      var sUrlTags = new URLSearchParams(window.location.search).getAll('filter.p.tag');
      searchStyleTags = [];
      searchStyle.subs.forEach(function (s) {
        if (sUrlTags.indexOf(s.title) !== -1) searchStyleTags.push(s.title);
      });

      var sStyleSection = document.createElement('div');
      sStyleSection.className = 'sfd-search-style-section';
      var sh = '<button class="sfd-accordion__trigger" type="button"><span>Style</span><svg class="sfd-accordion__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></button>';
      sh += '<div class="sfd-accordion__body">';
      sh += '<div class="sfd-style-ms">';
      sh += '<button type="button" class="sfd-style-ms__toggle">' +
        '<span class="sfd-style-ms__label">Select style(s)</span>' +
        '<svg class="sfd-style-ms__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
        '</button>';
      sh += '<div class="sfd-style-ms__menu">';
      searchStyle.subs.forEach(function (s) {
        var checked = searchStyleTags.indexOf(s.title) !== -1;
        sh += '<label class="sfd-style-ms__option">' +
          '<input type="checkbox" class="sfd-style-ms__cb" value="' + s.title.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + '>' +
          '<span class="sfd-style-ms__check"></span>' +
          '<span class="sfd-style-ms__text">' + s.title + '</span>' +
          '</label>';
      });
      sh += '</div></div></div>';
      sStyleSection.innerHTML = sh;
      content.appendChild(sStyleSection);

      if (targetId === 'sfd-style-search') {
        sStyleSection.classList.add('is-open');
        var sms = qs('.sfd-style-ms', sStyleSection);
        if (sms) sms.classList.add('is-open');
        setTimeout(function () { sStyleSection.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
      }
    }

    // Render drawer pills + set view button count
    renderDrawerPills();
    setViewButtonCount();

    // Show drawer
    drawer.classList.add('is-open');
    backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // Highlight active bar button
    qsa('.sfd-bar__btn', bar).forEach(function (b) { b.classList.remove('is-active'); });
    var activeBtn = qs('[data-target="' + targetId + '"]', bar);
    if (activeBtn) activeBtn.classList.add('is-active');

    // Scroll to target
    if (targetId === 'sort') {
      setTimeout(function () { sortSection.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
    } else if (targetId.startsWith('filter-')) {
      var idx = parseInt(targetId.replace('filter-', ''), 10);
      var items = qsa('.facets__item', content);
      if (items[idx]) {
        setTimeout(function () { items[idx].scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
      }
    }
  }

  // --- Close Drawer (without applying) ---
  function closeDrawer() {
    if (!drawer) return;
    moveFiltersBack();
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
    qsa('.sfd-bar__btn', bar).forEach(function (b) { b.classList.remove('is-active'); });
    pendingSortIndex = null;
  }

  // --- Apply Filters (VIEW ITEMS click) ---
  function applyFilters() {
    if (!drawer) return;

    // Search page multi-select: filter the search results by selected style
    // tags (preserving the `q` query) via filter.p.tag.
    if (searchStyleTags.length > 0) {
      window.location.href = buildSearchStyleUrl();
      return;
    }

    // Search two-level (legacy): a single sub-collection chosen — navigate to it.
    if (pendingStyle && pendingStyle.url) {
      window.location.href = buildStyleUrl();
      return;
    }

    // Collection multi-select: filter the current collection by selected style tags.
    if (collectionStyleTags.length > 0) {
      window.location.href = buildCollectionStyleUrl();
      return;
    }

    // Apply sort if user selected one
    if (pendingSortIndex !== null) {
      var sortingFilter = qs('.facets--horizontal .sorting-filter');
      if (sortingFilter) {
        var sortDetails = qs('details', sortingFilter);
        var sortOptions = sortDetails ? qsa('[role="option"]', sortDetails) : [];
        if (sortOptions[pendingSortIndex]) {
          sortOptions[pendingSortIndex].click();
        }
      }
      pendingSortIndex = null;
    }

    // Move filters back to form
    moveFiltersBack();

    // Trigger the theme's filter update
    var facets = qs('.facets--horizontal');
    if (facets) {
      var facetInputsComp = qs('facet-inputs-component', facets);
      if (facetInputsComp && facetInputsComp.updateFilters) {
        facetInputsComp.updateFilters();
      } else {
        // Fallback: dispatch change on first input
        var firstInput = qs('input[type="checkbox"], input[type="text"]', facets);
        if (firstInput) firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Close drawer
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
    qsa('.sfd-bar__btn', bar).forEach(function (b) { b.classList.remove('is-active'); });

    // Update bar pills after a delay (wait for morph)
    setTimeout(renderBarPills, 500);
  }

  // --- Move filters back from drawer to overflow list ---
  function moveFiltersBack() {
    var content = qs('.sfd-drawer__content', drawer);
    var overflowList = qs('.facets--horizontal .facets__overflow-list');
    if (!content || !overflowList) return;

    qsa('.facets__item', content).forEach(function (item) {
      overflowList.appendChild(item);
      item.style.display = '';
      item.style.visibility = '';
      item.style.position = '';
      item.style.width = '';
      var details = qs('details', item);
      if (details) {
        details.removeAttribute('open');
        details.setAttribute('data-auto-close-details', 'desktop');
      }
    });
  }

  // --- Set VIEW button product count ---
  function setViewButtonCount() {
    var viewBtn = qs('.sfd-drawer__view-btn', drawer);
    if (!viewBtn) return;
    var statusEl = qs('[role="status"]');
    if (statusEl) {
      var match = statusEl.textContent.trim().match(/(\d+)/);
      if (match) {
        viewBtn.textContent = 'VIEW ' + match[1] + ' ITEMS';
        return;
      }
    }
    viewBtn.textContent = 'VIEW ITEMS';
  }

  // --- Collect the currently selected filters as URL query params ---
  function collectFilterParams() {
    var params = [];
    var seen = {};
    // Checked facet checkboxes (may live in the form or moved into the drawer)
    qsa(
      '.facets--horizontal input[type="checkbox"]:checked,' +
      '.facets-drawer__filters input[type="checkbox"]:checked,' +
      '.sfd-drawer__content input[type="checkbox"]:checked'
    ).forEach(function (input) {
      if (!input.name || !input.value) return;
      // Skip native Style (Tags) facet — our custom filter appends
      // filter.p.tag itself, so including it here would double-add.
      if (input.name === 'filter.p.tag') return;
      var key = input.name + '::' + input.value;
      if (seen[key]) return;
      seen[key] = true;
      params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
    });
    // Price range
    var minPrice = qs('input[name*="filter.v.price.gte"]');
    var maxPrice = qs('input[name*="filter.v.price.lte"]');
    if (minPrice && minPrice.value) params.push(encodeURIComponent(minPrice.name) + '=' + encodeURIComponent(minPrice.value));
    if (maxPrice && maxPrice.value) params.push(encodeURIComponent(maxPrice.name) + '=' + encodeURIComponent(maxPrice.value));
    // Sort — pending selection wins, else keep current
    var sortValue = null;
    if (pendingSortIndex !== null) {
      var sortingFilter = qs('.facets--horizontal .sorting-filter');
      var sortDetails = sortingFilter ? qs('details', sortingFilter) : null;
      var sortOptions = sortDetails ? qsa('[role="option"]', sortDetails) : [];
      var opt = sortOptions[pendingSortIndex];
      if (opt) sortValue = opt.getAttribute('data-value') || opt.dataset.value || opt.getAttribute('value') || null;
    }
    if (!sortValue) sortValue = new URLSearchParams(window.location.search).get('sort_by');
    if (sortValue) params.push('sort_by=' + encodeURIComponent(sortValue));
    return params;
  }

  // --- Build the sub-collection URL with current filters appended (search single) ---
  function buildStyleUrl() {
    if (!pendingStyle || !pendingStyle.url) return window.location.pathname;
    var base = pendingStyle.url.split('?')[0];
    var params = collectFilterParams();
    return base + (params.length ? '?' + params.join('&') : '');
  }

  // --- Collection multi-select Style: filter the CURRENT collection by the
  //     selected sub-category tags, plus the other filters. ---
  function buildCollectionStyleUrl() {
    var base = window.location.pathname;
    var params = collectFilterParams();
    collectionStyleTags.forEach(function (t) {
      params.push('filter.p.tag=' + encodeURIComponent(t));
    });
    return base + (params.length ? '?' + params.join('&') : '');
  }

  // --- Search page multi-select Style: filter the search RESULTS by the
  //     selected sub-category tags, preserving the `q` query + other filters. ---
  function buildSearchStyleUrl() {
    var base = window.location.pathname; // /search
    var params = collectFilterParams();
    var q = new URLSearchParams(window.location.search).get('q');
    if (q) params.unshift('q=' + encodeURIComponent(q));
    searchStyleTags.forEach(function (t) {
      params.push('filter.p.tag=' + encodeURIComponent(t));
    });
    return base + (params.length ? '?' + params.join('&') : '');
  }

  function updateSearchStyleCount() {
    var viewBtn = qs('.sfd-drawer__view-btn', drawer);
    if (viewBtn) viewBtn.textContent = 'LOADING...';
    fetch(buildSearchStyleUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var countEl = doc.querySelector('[role="status"]');
        var m = countEl ? countEl.textContent.trim().match(/(\d+)/) : null;
        if (viewBtn) viewBtn.textContent = m ? 'VIEW ' + m[1] + ' ITEMS' : 'VIEW ITEMS';
      })
      .catch(function () { if (viewBtn) viewBtn.textContent = 'VIEW ITEMS'; });
  }

  function updateCollectionStyleCount() {
    var viewBtn = qs('.sfd-drawer__view-btn', drawer);
    if (viewBtn) viewBtn.textContent = 'LOADING...';
    fetch(buildCollectionStyleUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var countEl = doc.querySelector('[role="status"]');
        var m = countEl ? countEl.textContent.trim().match(/(\d+)/) : null;
        if (viewBtn) viewBtn.textContent = m ? 'VIEW ' + m[1] + ' ITEMS' : 'VIEW ITEMS';
      })
      .catch(function () { if (viewBtn) viewBtn.textContent = 'VIEW ITEMS'; });
  }

  // --- Update VIEW button with the pending style collection's product count ---
  function updateStyleViewCount() {
    if (!pendingStyle || !pendingStyle.url) return;
    var viewBtn = qs('.sfd-drawer__view-btn', drawer);
    if (viewBtn) viewBtn.textContent = 'LOADING...';
    fetch(buildStyleUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var countEl = doc.querySelector('[role="status"]');
        var m = countEl ? countEl.textContent.trim().match(/(\d+)/) : null;
        if (viewBtn) viewBtn.textContent = m ? 'VIEW ' + m[1] + ' ITEMS' : 'VIEW ITEMS';
      })
      .catch(function () { if (viewBtn) viewBtn.textContent = 'VIEW ITEMS'; });
  }

  // --- Fetch product count (debounced) ---
  var countTimeout = null;
  function fetchProductCount() {
    clearTimeout(countTimeout);
    countTimeout = setTimeout(function () {
      var content = qs('.sfd-drawer__content', drawer);
      if (!content) return;
      var params = [];
      qsa('input[type="checkbox"]:checked', content).forEach(function (input) {
        if (input.name && input.value) {
          params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
        }
      });
      // Price inputs
      var minPrice = qs('input[name*="filter.v.price.gte"]', content);
      var maxPrice = qs('input[name*="filter.v.price.lte"]', content);
      if (minPrice && minPrice.value) params.push(encodeURIComponent(minPrice.name) + '=' + encodeURIComponent(minPrice.value));
      if (maxPrice && maxPrice.value) params.push(encodeURIComponent(maxPrice.name) + '=' + encodeURIComponent(maxPrice.value));
      // Sort
      var urlParams = new URLSearchParams(window.location.search);
      var sortBy = urlParams.get('sort_by');
      if (sortBy) params.push('sort_by=' + encodeURIComponent(sortBy));
      // Preserve the search term on the search page — without `q` the
      // /search fetch returns no results and the count can't be read.
      var searchTerm = urlParams.get('q');
      if (searchTerm) params.unshift('q=' + encodeURIComponent(searchTerm));

      var fetchUrl = window.location.pathname + (params.length > 0 ? '?' + params.join('&') : '');
      var viewBtn = qs('.sfd-drawer__view-btn', drawer);
      if (viewBtn) viewBtn.textContent = 'LOADING...';

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var countEl = doc.querySelector('[role="status"]');
          var countText = countEl ? countEl.textContent.trim() : '';
          var countNum = countText.match(/(\d+)/);
          if (viewBtn) viewBtn.textContent = countNum ? 'VIEW ' + countNum[1] + ' ITEMS' : 'VIEW ITEMS';
        })
        .catch(function () {
          if (viewBtn) viewBtn.textContent = 'VIEW ITEMS';
        });
    }, 300);
  }

  // --- Event Handlers ---
  function handleBarClick(e) {
    var btn = e.target.closest('.sfd-bar__btn');
    var pillX = e.target.closest('.sfd-pill__x');
    var clearBtn = e.target.closest('.sfd-pills-clear');

    if (btn) {
      openDrawer(btn.dataset.target);
    }
  }

  // Handle pill clicks on bar pills container (sibling of bar)
  document.addEventListener('click', function (e) {
    var pillX = e.target.closest('.sfd-bar__pills .sfd-pill__x');
    var clearBtn = e.target.closest('.sfd-bar__pills .sfd-pills-clear');
    if (pillX) {
      var idx = parseInt(pillX.dataset.pillIndex, 10);
      var active = getActiveFilters();
      if (active[idx]) {
        removeFilter(active[idx].input);
        setTimeout(renderBarPills, 500);
      }
    } else if (clearBtn) {
      window.location.href = window.location.pathname;
    }
  });

  function handleDrawerClick(e) {
    // Close button
    if (e.target.closest('.sfd-drawer__close')) {
      closeDrawer();
      return;
    }
    // VIEW ITEMS button
    if (e.target.closest('.sfd-drawer__view-btn')) {
      applyFilters();
      return;
    }
    // Sort / Style accordion trigger
    if (e.target.closest('.sfd-accordion__trigger')) {
      var accSection = e.target.closest('.sfd-sort-section, .sfd-style-section, .sfd-search-style-section');
      if (accSection) accSection.classList.toggle('is-open');
      return;
    }
    // Search Style: expand/collapse a main category to reveal its sub-collections
    if (e.target.closest('.sfd-sstyle-main__toggle')) {
      var mainWrap = e.target.closest('.sfd-sstyle-main');
      if (mainWrap) mainWrap.classList.toggle('is-open');
      return;
    }
    // Search Style: a sub-collection chosen — store as pending (applied on VIEW ITEMS)
    var sStyleOpt = e.target.closest('.sfd-sstyle-option');
    if (sStyleOpt) {
      e.preventDefault();
      pendingStyle = { url: sStyleOpt.getAttribute('href'), title: sStyleOpt.textContent.trim() };
      qsa('.sfd-sstyle-option', drawer).forEach(function (o) { o.classList.remove('is-active'); });
      sStyleOpt.classList.add('is-active');
      renderDrawerPills();
      updateStyleViewCount();
      return;
    }
    // Collection Style multi-select dropdown toggle (stays open on option clicks)
    if (e.target.closest('.sfd-style-ms__toggle')) {
      var msWrap = e.target.closest('.sfd-style-ms');
      if (msWrap) msWrap.classList.toggle('is-open');
      return;
    }
    // Clear a pending style pill
    if (e.target.closest('[data-style-clear]')) {
      pendingStyle = null;
      var ddReset = qs('.sfd-style-dropdown', drawer);
      if (ddReset) {
        qsa('.sfd-style-dropdown__option', ddReset).forEach(function (o) { o.classList.remove('is-active'); });
        var lbl2 = qs('.sfd-style-dropdown__label', ddReset);
        if (lbl2) lbl2.textContent = 'Select a style';
      }
      // Also clear the search two-level style selection
      qsa('.sfd-sstyle-option', drawer).forEach(function (o) { o.classList.remove('is-active'); });
      renderDrawerPills();
      setViewButtonCount();
      return;
    }
    // Remove a single collection Style tag pill (multi-select)
    var styleTagX = e.target.closest('[data-style-tag]');
    if (styleTagX) {
      var tagVal = styleTagX.getAttribute('data-style-tag');
      collectionStyleTags = collectionStyleTags.filter(function (t) { return t !== tagVal; });
      qsa('.sfd-style-ms__cb', drawer).forEach(function (cb) { if (cb.value === tagVal) cb.checked = false; });
      renderDrawerPills();
      updateCollectionStyleCount();
      return;
    }
    // Remove a single SEARCH Style tag pill (multi-select)
    var sStyleTagX = e.target.closest('[data-sstyle-tag]');
    if (sStyleTagX) {
      var sTagVal = sStyleTagX.getAttribute('data-sstyle-tag');
      searchStyleTags = searchStyleTags.filter(function (t) { return t !== sTagVal; });
      qsa('.sfd-search-style-section .sfd-style-ms__cb', drawer).forEach(function (cb) { if (cb.value === sTagVal) cb.checked = false; });
      renderDrawerPills();
      updateSearchStyleCount();
      return;
    }
    // Drawer pill X
    var pillX = e.target.closest('.sfd-drawer__pills .sfd-pill__x');
    if (pillX) {
      var idx = parseInt(pillX.dataset.pillIndex, 10);
      var active = getActiveFilters();
      if (active[idx]) {
        removeFilter(active[idx].input);
      }
      return;
    }
    // Drawer CLEAR
    if (e.target.closest('.sfd-drawer__clear-btn')) {
      window.location.href = window.location.pathname;
      return;
    }
  }

  function handleDrawerChange(e) {
    // Style multi-select checkbox toggled — same UI on collection & search.
    // Route to the right state by which section it lives in.
    if (e.target.classList && e.target.classList.contains('sfd-style-ms__cb')) {
      if (e.target.closest('.sfd-search-style-section')) {
        searchStyleTags = qsa('.sfd-search-style-section .sfd-style-ms__cb:checked', drawer).map(function (cb) { return cb.value; });
        renderDrawerPills();
        updateSearchStyleCount();
      } else {
        collectionStyleTags = qsa('.sfd-style-ms__cb:checked', drawer).map(function (cb) { return cb.value; });
        renderDrawerPills();
        updateCollectionStyleCount();
      }
      return;
    }
    // Sort radio — just store, don't apply
    if (e.target.name === 'sfd-sort-radio') {
      pendingSortIndex = parseInt(e.target.value, 10);
      return;
    }
    // Filter checkbox changed — update pills + fetch count
    renderDrawerPills();
    if (pendingStyle) {
      updateStyleViewCount();
    } else {
      fetchProductCount();
    }
  }

  // --- Initialize ---
  function init() {
    ensureUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // --- Re-initialize after section morph ---
  var reinitTimeout = null;
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) {
          var el = added[j];
          var hasFacets = el.querySelector && el.querySelector('.facets--horizontal');
          var isFacets = el.classList && el.classList.contains('facets--horizontal');
          if (hasFacets || isFacets) {
            // Section was re-rendered — remove old bar and re-init
            var oldBar = document.querySelector('.sfd-bar');
            var oldPills = document.querySelector('.sfd-bar__pills');
            if (oldBar) oldBar.remove();
            if (oldPills) oldPills.remove();
            // Also remove stale drawers/backdrops so they don't stack up
            var openDrawerEl = document.querySelector('.sfd-drawer.is-open');
            if (!openDrawerEl) {
              document.querySelectorAll('.sfd-drawer, .sfd-backdrop').forEach(function (el) { el.remove(); });
              drawer = null;
              backdrop = null;
            }
            bar = null;
            clearTimeout(reinitTimeout);
            reinitTimeout = setTimeout(init, 300);
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback polling
  setInterval(function () {
    if (!document.querySelector('.sfd-bar') && document.querySelector('.facets--horizontal')) {
      bar = null;
      init();
    }
  }, 2000);
})();
